<form [formGroup]="resellerFormGroup" (ngSubmit)="onSubmit()" #resellerFormRef="ngForm">
    <div class="modal-body">
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Rut</label>
                <div class="col-9">
                    <input type="text" class="form-control" id="rutCompleto" formControlName="rutCompleto"
                        [attr.disabled]="detailMode||editMode?detailMode||editMode:null"
                        placeholder="Ingrese Rut de Reseller" [ngClass]="{
                        'is-invalid':resellerFormRef.submitted && resellerFormGroup.get('rutCompleto').invalid
                    }">
                    <div *ngIf="resellerFormRef.submitted &&( resellerFormGroup.get('rutCompleto').invalid ||  resellerFormGroup.get('rutCompleto').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="resellerFormGroup.get('rutCompleto').hasError('VerificacionRutValidator')">
                            Rut inválido</div>
                        <div *ngIf="resellerFormGroup.get('rutCompleto').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Razón Social</label>
                <div class="col-9">
                    <input type="text" class="form-control" id="razonSocial" formControlName="razonSocial"
                        [attr.disabled]="detailMode?detailMode:null" placeholder="Ingrese Razón Social" [ngClass]="{
                        'is-invalid':resellerFormRef.submitted && resellerFormGroup.get('razonSocial').invalid
                    }">
                    <div *ngIf="resellerFormRef.submitted &&( resellerFormGroup.get('razonSocial').invalid ||  resellerFormGroup.get('razonSocial').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="resellerFormGroup.get('razonSocial').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Domicilio</label>
                <div class="col-9">
                    <input type="text" class="form-control" id="domicilio" formControlName="domicilio"
                        [attr.disabled]="detailMode?detailMode:null" placeholder="Ingrese Domicilio" [ngClass]="{
                        'is-invalid':resellerFormRef.submitted && resellerFormGroup.get('domicilio').invalid
                    }">
                    <div *ngIf="resellerFormRef.submitted &&( resellerFormGroup.get('domicilio').invalid ||  resellerFormGroup.get('domicilio').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="resellerFormGroup.get('domicilio').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Comuna</label>
                <div class="col-9">
                    <input type="text" class="form-control" id="comuna" formControlName="comuna"
                        [attr.disabled]="detailMode?detailMode:null" placeholder="Ingrese Comuna" [ngClass]="{
                        'is-invalid':resellerFormRef.submitted && resellerFormGroup.get('comuna').invalid
                    }">
                    <div *ngIf="resellerFormRef.submitted &&( resellerFormGroup.get('comuna').invalid ||  resellerFormGroup.get('comuna').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="resellerFormGroup.get('comuna').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Ciudad</label>
                <div class="col-9">
                    <input type="text" class="form-control" id="ciudad" formControlName="ciudad"
                        [attr.disabled]="detailMode?detailMode:null" placeholder="Ingrese Ciudad" [ngClass]="{
                        'is-invalid':resellerFormRef.submitted && resellerFormGroup.get('ciudad').invalid
                    }">
                    <div *ngIf="resellerFormRef.submitted &&( resellerFormGroup.get('ciudad').invalid ||  resellerFormGroup.get('ciudad').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="resellerFormGroup.get('ciudad').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Nombre Contacto</label>
                <div class="col-9">
                    <input type="text" class="form-control" id="nombreContacto" formControlName="nombreContacto"
                        [attr.disabled]="detailMode?detailMode:null" placeholder="Ingrese nombre del contacto"
                        [ngClass]="{
                        'is-invalid':resellerFormRef.submitted && resellerFormGroup.get('nombreContacto').invalid
                    }">
                    <div *ngIf="resellerFormRef.submitted &&( resellerFormGroup.get('nombreContacto').invalid ||  resellerFormGroup.get('nombreContacto').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="resellerFormGroup.get('nombreContacto').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Telefono Contacto</label>
                <div class="col-9">
                    <input
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        maxlength="9" min="1" type="number" class="form-control" id="telefonoContacto"
                        formControlName="telefonoContacto" [attr.disabled]="detailMode?detailMode:null"
                        placeholder="Ingrese telefono del contacto" [ngClass]="{
                        'is-invalid':resellerFormRef.submitted && resellerFormGroup.get('telefonoContacto').invalid
                    }">
                    <div *ngIf="resellerFormRef.submitted &&( resellerFormGroup.get('telefonoContacto').invalid ||  resellerFormGroup.get('telefonoContacto').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="resellerFormGroup.get('telefonoContacto').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Email Contacto</label>
                <div class="col-9">
                    <input type="text" class="form-control" id="emailContacto" formControlName="emailContacto"
                        [attr.disabled]="detailMode?detailMode:null" placeholder="Ingrese email de contacto" [ngClass]="{
                        'is-invalid':resellerFormRef.submitted && resellerFormGroup.get('emailContacto').invalid
                    }">
                    <div *ngIf="resellerFormRef.submitted &&( resellerFormGroup.get('emailContacto').invalid ||  resellerFormGroup.get('emailContacto').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="resellerFormGroup.get('emailContacto').errors?.required">Campo requerido</div>
                        <div *ngIf="resellerFormGroup.get('emailContacto').hasError('wrongEmail')">Correo inválido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Usar Logo Propio</label>
                <div class="col-9">
                    <input type="checkbox" class="input-checkbox" id="usarLogo" formControlName="usarLogo"
                        [attr.disabled]="detailMode?detailMode:null">
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row current-logo-container" *ngIf="resellerToEdit && resellerToEdit.logoFile">
                <div class="col-10 offset-sm-2 mb-3">
                    <img [src]="'data:image/png;base64,'+resellerToEdit.logoFile" alt="logo actual"
                        class="img-thumbnail">
                </div>
            </div>
            <div class="row new-logo-container mb-3" *ngIf="resellerObj.logoFile && files[0]">
                <div class="col-10 offset-sm-2">
                    <img [src]="'data:image/png;base64,'+resellerObj.logoFile" alt="logo cargado" class="img-thumbnail">

                </div>
            </div>
            <div class="row">
                <label for="" class="col-3 label-control">Logo Reseller</label>
                <div class="col-9">
                    <ngx-dropzone class="ml-5" [disabled]="detailMode" (change)="onSelect($event)" maxFileSize="2097152"
                        accept="image/jpg,image/jpeg,image/png" multiple=false>
                        <ngx-dropzone-label class="px-5">
                            <i class="flaticon-upload"></i>
                            <p>Arrastra o selecciona un archivo con la imagen del logo a utilizar</p>

                            <p>El formato del archivo debe ser .png o .jpg</p>
                        </ngx-dropzone-label>
                        <!-- <ngx-dropzone-label class="d-inline">
                           
                        </ngx-dropzone-label> -->
                        <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                            <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                        </ngx-dropzone-preview>
                    </ngx-dropzone>
                    <div *ngIf="resellerFormRef.submitted && (resellerFormGroup.get('logoCompleteFile').invalid || (resellerFormGroup.get('logoCompleteFile').dirty || resellerFormGroup.get('logoCompleteFile').touched || resellerFormGroup.get('logoCompleteFile').value == null))"
                        class="invalid-feedback mx-auto drop-feedback px-40">
                        <div *ngIf='resellerFormGroup.get("logoCompleteFile").errors?.required' class="px-10">Campo
                            requerido</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" id="add-contact-item" class="btn btn-success add-contact-item" *ngIf="!detailMode">
            <i class="la la-paper-plane-o d-lg-none"></i>
            <span class="d-none d-lg-block">Guardar</span>
        </button>
        <button type="button" class="btn btn-secondary ml-3" (click)="closeResellerModal()">
            <span class="d-none d-lg-block">Cerrar</span>
        </button>
    </div>
</form>